import React, { Component } from 'react';
import { Button, Tabs, Row, Col, Modal, Icon, Input, message, Form, Table, LocaleProvider, Select, DatePicker, Radio, Upload } from 'antd';
import Crumbs from './../../../Crumbs/Crumbs';//面包屑
import evn from "./../../../../../actions/index";//action的所有事件
import { connect } from "react-redux";//联系store的组件
import CaseDetailsInfoModal from "./../../../Common/CaseDetailsInfoModal";//登记单详情
import EventSet from "./../../../../../assets/PubJs/hcPub";//公用的所有事件
import { Hcurl, UpLoadedFilesUrl, uploadAction } from "./../../../../../constants/index";//获取公共路径
import Event from "./../../../../../assets/PubJs/hcPub";//所有事件
import CompanysModal from './CompanyModal.js';//切换企业弹框
import RegistrationCommon from './RegistrationCommon.js';
import $ from "jquery";
import downLoad from "./../../../../../assets/images/downLoad.png";
import editDown from "./../../../../../assets/images/editDown.png";
import CompanyFristLogin from './../../CompanyCenter/CompanyFristLogin/CompanyFristLogin';
import createHistory from 'history/createHashHistory';//路由切换地址
import zhCN from 'antd/lib/locale-provider/zh_CN';
import "./../style.css"
import moment from 'moment';
const { MonthPicker, RangePicker } = DatePicker;
const Option = Select.Option;
const history = createHistory();//定义history路由
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { TextArea } = Input;

let _selectedRows = '';
//批量登记
var _AllEdit = null;
var _selectedRowKeys = [];
class AllEdit extends React.Component {
    state = {
        visible: false,
        fileList: [],
        disabledModalbtn: true,
        DepartCode: "",
        loading: false,
        sureBtn: "确定"
    }
    handleChange = (info) => {  //文件上传方法
        this.setState({
            dataName: info.file.name
        })
        let fileList = info.fileList;

        if (info.file.status === 'done') {
            message.success(`${info.file.name} 文件上传成功`);
            $('.registration').html('<span style=\'padding:0 6px 0 6px\'>正在校验数据，请稍等...</span>');
            console.log(info, 'infsso');
            $.ajax({
                //url: Hcurl + "/AF_CompanyCaseInfo/ValidateExcel?file=/" + info.file.response.substr(info.file.response.indexOf('wisdom315_BusinessAPI')),
                url: Hcurl + "/AF_CompanyCaseInfo/ValidateExcel?file=" + encodeURIComponent(info.file.response),
                type: "post",
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    console.log(data, 'success');
                    if (data.message == 'true') {
                        var suc = '<p class="ietmps">数据无误，请点击“确定”进行导入！</p>';
                        $('.registration').html(suc);
                        _AllEdit.setState({
                            disabledModalbtn: false
                        })
                    } else {
                        if (data.message.indexOf('|') >= 0) {
                            if (data.message.split('|')[1] == '导入数据格式错误，请查看各列列头名称是否符合模版要求') {
                                $('.registration').html('<span style=\"color:#FF0000;padding:0 10px 10px;\">导入数据格式错误，请查看各列列头名称是否符合模版要求</span>');
                            } else if (data.message.split('|')[1] == '内容超过800行请整理法规后重新上传') {
                                $('.registration').html('<span style=\"color:#FF0000;padding:0 10px 10px;\">excel文件最多800行。</span>');
                            } else if (data.message.split('|')[1] == '文件损坏') {
                                $('.registration').html('<span style=\"color:#FF0000;padding:0 10px 10px;\">导入数据格式错误，请查看各列列头名称是否符合模版要求</span>');
                            } else if (data.message.split('|')[1] == '内容为空请重新上传') {
                                $('.registration').html('<span style=\"color:#FF0000;padding:0 10px 10px;\">导入数据内容为空，请检查后重新导入</span>');
                            } else {
                                var str = '';
                                var more = '<p class="ietmp">检测到有大量数据不符合数据规范要求，请仔细检查后重新导入</p>';
                                data.data.map(function (ietm, idx) {
                                    var firstInfo ='<span style=\"color:#FF0000;padding:0 10px 10px;\">以下数据不符合数据规范：</span>'
                                    if (idx <= 19) {
                                        str += '<p class="ietmp">' + ietm + '</p>';
                                        $('.registration').html(firstInfo+str)
                                    } else {
                                        $('.registration').html(firstInfo+str + more);
                                    }
                                })
                            }
                        }
                    }

                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    console.log(data, 'error')
                }
            })

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 文件上传失败`);
        }
        fileList = fileList.map((file) => {
            if (file.response) {
                file.url = file.response;
            }
            return file;
        });
        fileList = fileList.filter((file) => {
            if (file.size < 20971520) {
                return true;
            } else
                return false;
        });
        this.setState({
            fileList
        })



        console.log('fileList1111', this.state.fileList);
    }
    beforeUpload = (file) => {
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isLt2M) {
            message.error('单个附件大小最多20M');
        } else {
            this.setState({ dataName: file.name })
        }
        return true;
    }
    componentDidMount() {
        _AllEdit = this;
    }
    //获取企业企业直属部门Code
    GetComUEDepartmentCode = () => {
        $.ajax({
            url: Hcurl + "/AF_CompanyCaseInfo/GetComUEDepartmentCode?CompanyCode=" + _this.state.companyCode,
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                if (data != '' && data != null) {
                    _AllEdit.setState({
                        DepartCode: data
                    })
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }
        })
    }
    showContent = () => {
        if ($('.uls').css('display') == 'none') {
            $('.uls').css('display', 'block')
            $('.editImg').css('transform', 'rotate(180deg)')
        } else {
            $('.uls').css('display', 'none');
            $('.editImg').css('transform', 'rotate(0deg)');
        }
    }
    ok = () => {
        this.setState({
            loading: true,
            sureBtn: "保存中"
        })
        let fileUrl = this.state.fileList[0].response;
        $.ajax({
            url: Hcurl + "/AF_CompanyCaseInfo/InsertDatas?file=" + encodeURIComponent(fileUrl) + '&CI_UserCode=' + EventSet.getUserInfo().CU_Code + '&CI_DepartCode=' + _AllEdit.state.DepartCode + '&CI_ComCode=' + EventSet.getUserInfo().xxhjcompanycode + '&JoinMan=' + EventSet.getUserInfo().CU_Code,
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            //timeout: 5, //超时时间设置，单位毫秒
            //complete: function (XMLHttpRequest, status) {
            //    console.log(status, XMLHttpRequest, 'status');
            //    if (status == 'timeout') {//超时,status还有success,error等值的情况
            //        ajaxTimeoutTest.abort();
            //        message.warn("请求超时");
            //    }
            //},
            success: function (data) {
                console.log(data, 'success')
                if (data.indexOf('|') >= 0) {
                    if (data.split('|')[0] == 'true') {
                        message.success(data.split('|')[1]);
                        const pagination = { ..._this.state.pagination }
                        pagination.current = 1;
                        _this.setState({
                            pagination: pagination
                        })
                        setTimeout(() => { _this.GetCaseInfoPageList(); }, 20)
                    } else {
                        _AllEdit.setState({
                            loading: false
                        })
                        message.warn(data.split('|')[1]);
                    }
                    _AllEdit.setState({
                        visible: false,
                    })
                }
            },
            error: function (data) {
                console.log(data, 'error');
                message.error('操作失败');
                _AllEdit.setState({
                    loading: false
                })
                //history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            },

        })
    }
    Cancle = () => {
        this.setState({
            visible: false,
        })

    }
    dowmLoad = () => {
        window.location.href = UpLoadedFilesUrl;
    }
    remove = (fileList) => {
        var more = '<span id="spn">上传完毕后，此处可以查看数据校验后的结果，校验成功后方可完成此次批量登记操作。</span>';
        $('.registration').html(more)
        this.setState({
            disabledModalbtn: true
        })
    }

    render() {
        const head = {
            "token": EventSet.getUserInfo()['token']
        }
        // const head = { authorization: 'authorization-text'}

        return (
            <div style={{ width: "700px !important" }}>
                <Modal
                    visible={this.state.visible}
                    title='批量登记'
                    width='610px'
                    onCancel={this.Cancle}
                    footer={[
                        <Button key="back" onClick={this.Cancle}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loading} onClick={this.ok} disabled={this.state.disabledModalbtn}>
                            {this.state.sureBtn}
                        </Button>,
                    ]}
                >
                    <div style={{ height: 400, overflowX: "auto" }}>
                        <p>1、准备数据</p>
                        <p style={{ paddingLeft: 23 }}>模版中各列名称中的批注内容已列出相应要求，请按规则进行导入；<a onClick={this.showContent}>相关数据标准<img src={editDown} className='editImg' style={{ marginLeft: 3 }} /></a></p>
                        <ul style={{ listStyle: "none", display: "none", marginLeft: "-16px", color: "#999" }} className='uls'>
                            <li>投诉日期：必填，符合日期格式，如：2018/1/1</li>
                            <li>投诉人姓名：必填，文本长度不得大于20个字</li>
                            <li>投诉人联系电话：必填，6~18位纯数字</li>
                            <li>商品/服务：必填，文本长度不得大于50个字</li>
                            <li>购货日期：必填，数据导入时必须符合日期格式内容</li>
                            <li>纠纷内容：必填，文本长度不得大于1000个字</li>
                            <li>和解结果：必填，限定0或1; 注：0表示和解成功，1表示和解失败</li>
                            <li>处理结果：必填，文本长度不得大于400个字</li>
                            <li>争议金额（元）：必填，0.00~999999999.99的数值</li>
                            <li>退赔金额（元）：必填，0.00~999999999.99的数值</li>
                            <li>受理人姓名：必填，文本长度不得大于20个字</li>
                        </ul>
                        <p style={{ paddingLeft: 23 }}><a onClick={this.dowmLoad}><img src={downLoad} style={{ verticalAlign: 'sub' }} />下载导入模板</a></p>


                        <p>2、上传数据文件</p>
                        <Row style={{ paddingLeft: 23 }}>
                            <Col span={8}>
                                {(this.state.fileList.length >= 1) ? <Upload
                                    name="file"
                                    //action="https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx"
                                    action={uploadAction}
                                    onChange={this.handleChange}
                                    beforeUpload={this.beforeUpload}
                                    fileList={this.state.fileList}
                                    headers={head}
                                    // disabled={false}
                                    style={{ display: "inlineBlock" }}
                                    accept=".xls,.xlsx"
                                    directory={false}
                                    // disabled={true}
                                    onRemove={this.remove}
                                >
                                    <Button disabled={true}><Icon type="upload" /> 点击上传附件</Button>
                                </Upload> 
                                : <Upload
                                    name="file"
                                    //action='http://211.149.250.2:20001/wisdom315_BusinessAPI/api/CompanyCore/FileUrl'
                                    //  action='http://211.149.250.2:20001/wisdom315_BusinessAPI/ASHX/UploadHandler.ashx'
                                    action={uploadAction}
                                    onChange={this.handleChange}
                                    beforeUpload={this.beforeUpload}
                                    fileList={this.state.fileList}
                                    headers={head}
                                    // disabled={false}
                                    style={{ display: "inlineBlock" }}
                                    accept=".xls,.xlsx"
                                    directory={false}
                                    // disabled={false}
                                    onPreview={this.Preview}
                                >
                                    <Button disabled={false}>
                                        <Icon type="upload" /> 点击上传附件
                                    </Button>
                                </Upload>}
                            </Col>
                            <Col span={12}>
                                <span style={{ verticalAlign: "sub" }}> 目前支持的文件类型为*.xls，*.xlsx。</span>
                            </Col>
                        </Row>
                        <div style={{ width: "92%", margin: "30px auto 0" }} className='editDiv'>
                            <div className='registration'>
                                <span id='spn'> 上传完毕后，此处可以查看数据校验后的结果，校验成功后方可完成此次批量登记操作。</span>
                            </div>
                        </div>

                    </div>
                </Modal>
            </div>
        )
    }
}
//批量删除
var _deleteInfo = null;
var _obj = null;
class DeleteInfo extends React.Component {
    state = {
        visible: false
    }
    handleOk = () => {
        console.log(_obj, '_obj');
        if (_obj != null) {
            _this.DeleteCaseInfos();
        } else {
            this.selectedRow();
        }
        this.setState({
            visible: false
        })
    }
    selectedRow = () => {
        $.ajax({
            url: Hcurl + "/AF_CompanyCaseInfo/DeleteCaseInfo?ci_code=" + _selectedRows + '&userCode=' + EventSet.getUserInfo().CU_Code,
            type: 'post',
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                console.log(data, 'success');
                if (data.indexOf('|') >= 0) {
                    if (data.split('|')[0] == 'true') {
                        message.success(data.split('|')[1]);
                        _this.setState({
                            selectedRowKeys: []
                        })
                        const pagination = { ..._this.state.pagination }
                        pagination.current = 1;
                        _this.setState({
                            pagination: pagination
                        })
                        setTimeout(() => { _this.GetCaseInfoPageList(); }, 20)

                        //console.log(_selectedRows, '_selectedRows');
                    } else {
                        message.warn(data.split('|')[1]);
                    }
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }
        })
    }
    componentDidMount() {
        _deleteInfo = this;
    }
    handleCancel = () => {
        this.setState({
            visible: false
        })
    }
    render() {
        return (
            <div>
                <Modal
                    title={_obj == null ? '批量删除' : "删除确认"}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    {_obj == null ? <div>选中内容被删除后将彻底注销，无法进行恢复，确定要进行删除操作吗？</div> : <div>删除后将彻底注销此内容，无法进行恢复，确定要进行删除操作吗？</div>}
                </Modal>
            </div>
        )

    }
}
var searchVal = { code: "", editStartTime: "", editEndTime: "", tsStartTime: "", tsEndTime: "", phone: "", result: "" };
var _this = null;
var _dateString = [];//登记时间
var _dateStrings = [];//投诉日期
class App extends React.Component {
    state = {
        autoHeight: "",
        data: [], //数据源
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0
        },
        loading: false,
        pagetotalCount: 0,
        selectedRowKeys: [],
        editTimes: [,],//登记时间
        dateTimes: [,],//投诉日期
        Com_Name: EventSet.getUserInfo().XXHJCom_Name,
        visible: false,
        companyCode: (EventSet.getUserInfo().xxhjcompanycode == null || EventSet.getUserInfo().xxhjcompanycode) == '' ? "" : EventSet.getUserInfo().xxhjcompanycode,
        sorters: "CI_RegTime desc",
        Companyisshow: "",
        CaseCI_Code: "",
        visibles: false

    }
    autoHeight = () => {  //内容区域高度自适应
        let autoHeight = window.innerHeight - 429;
        this.setState({
            autoHeight: autoHeight
        })
    }
    componentDidMount() {
        searchVal = { code: "", editStartTime: "", editEndTime: "", tsStartTime: "", tsEndTime: "", phone: "", result: "" }
        _this = this;
        this.autoHeight();
        this.GetCaseInfoPageList();
        Event.NavShow(this, "/Content/Business/CompanyRegistration", "CompanyRegistration")//显示菜单
    }
    componentWillMount() {
    }
    GetCaseInfoPageList = () => {

        _this.setState({ loading: true });
        const pagination = { ..._this.state.pagination };
        $.ajax({
            url: Hcurl + "/AF_CompanyCaseInfo/GetCaseInfoPageList",
            type: "POST",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            data: {
                Ci_code: searchVal.code,
                RegBeginTime: searchVal.editStartTime,
                RegEndTime: searchVal.editEndTime,
                ComplainBeginTime: searchVal.tsStartTime,
                ComplainEndTime: searchVal.tsEndTime,
                LinkPhone: searchVal.phone,
                Ci_Result: searchVal.result,
                CompanyCode: _this.state.companyCode,
                pageSize: pagination.pageSize,
                pageNo: pagination.current,
                sortName: _this.state.sorters,
            },
            success: function (data) {
                _this.setState({
                    selectedRowKeys: []
                })
                if (data.Rows !== "" && data.Rows !== null) {
                    data = JSON.parse(data)
                    pagination.total = Number(data.TotalCount);
                    _this.setState({
                        loading: false,
                        data: data.Rows,
                        pagination: pagination,
                        pagetotalCount: data.TotalCount
                    })
                    _this.getAllPage();
                    if (_AllEdit != null && _AllEdit != '')
                        _AllEdit.GetComUEDepartmentCode();
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error');
            }
        })
    }
    getAllPage() {
        setTimeout(function () {
            let count = _this.state.pagination.total
            let size = _this.state.pagination.pageSize
            if (count % size !== 0) {
                let num = count - count % size
                _this.setState({
                    allPage: num / size + 1
                })
            } else {
                _this.setState({
                    allPage: count / size
                })
            }
        }, 20)
    }

    handleSearch = () => {
        const { form } = this.props;
        form.validateFields((err, fieldsValue) => {
            //console.log(fieldsValue, 'fieldsValue');
            searchVal.code = fieldsValue.Code;
            searchVal.editStartTime = _dateString[0];//登记开始时间
            searchVal.editEndTime = _dateString[1];  //登记结束时间
            searchVal.tsStartTime = _dateStrings[0];//投诉日期开始时间
            searchVal.tsEndTime = _dateStrings[1];//投诉日期结束时间
            searchVal.phone = fieldsValue.Phone;//联系电话
            searchVal.result = fieldsValue.result;//和解结果

            console.log(searchVal, 'searchVal');
            const pagination = { ..._this.state.pagination };
            pagination.current = 1;
            _this.setState({
                pagination: pagination
            })
            setTimeout(function () {
                _this.GetCaseInfoPageList();
            }, 20)
        })
    }
    allDete = () => {  //批量删除
        _deleteInfo.setState({
            visible: true
        })

    }
    Record = () => { //登记
        let url = window.location.href.split("#")[0] + "#/New/CompanyRecord?companyCode=" + _this.state.companyCode;
        window.open(url)
    }

    reSet = () => {  //重置
        this.props.form.resetFields();
        this.setState({
            editTimes: [,],
            dateTimes: [,]
        })
        _dateStrings = [];//投诉日期
        _dateString = [];//登记时间
    }
    onDateChange = (value, dateString) => {    //登记时间事件
        console.log(value, dateString);
         _dateString = dateString;
        //beginTime = dateString[0]
        //endTime = dateString[1]
        // this.setState({ editTimes: value });
        // console.log(value)


       let dealbeginTime = dateString[0]
       let dealendTime = dateString[1]
        if (dateString[0] != "" && dateString[1] != "") {
            if (dateString[0].split(' ')[1] == dateString[1].split(' ')[1] && dateString[0].split(' ')[0] == dateString[1].split(' ')[0]) {
                dealendTime = dateString[1].split(' ')[0] + ' ' + '23:59';
                dealbeginTime = dateString[0].split(' ')[0] + ' ' + '00:00';
                _dateString = [dealbeginTime,dealendTime]
                this.setState({
                    editTimes: [moment(dealbeginTime, 'YYYY-MM-DD HH:mm:ss'), moment(dealendTime, 'YYYY-MM-DD HH:mm:ss')]
                });
            } else {
                this.setState({
                    editTimes: [moment(dealbeginTime, 'YYYY-MM-DD HH:mm:ss'), moment(dealendTime, 'YYYY-MM-DD HH:mm:ss')]
                });
            }
        } else {
            this.setState({ editTimes: value });
        }
    }
    onDateChanges = (value, dateString) => {  //投诉日期
        _dateStrings = dateString;
        this.setState({ dateTimes: value });
    }
    toggleCompany = () => {     //切换企业方法
        this.setState({
            visible: true
        })
    }
    setDefaultCom = (value, visible, code) => {
        console.log(value, visible, code, '123123')  //企业的中文名，code
        //console.log(_this.state.selectedRowKeys, 'hasSelected');
        if (value != 'value') {
            this.setState({
                Com_Name: value,
                visible: visible,
                companyCode: code
            })
            setTimeout(() => {
                const pagination = { ..._this.state.pagination };
                pagination.current = 1;
                _this.setState({
                    pagination: pagination
                })
                _this.GetCaseInfoPageList()
            }, 40)
        } else {
            this.setState({
                visible: visible
            })
        }
    }
    AllEdits = () => { //批量登记
        _AllEdit.setState({
            visible: true,
            loading: false,
            fileList: [],
            disabledModalbtn: true,
            sureBtn: "确定"
        })
        $('.registration').html('<span id=\'spn\'> 上传完毕后，此处可以查看数据校验后的结果，校验成功后方可完成此次批量登记操作。</span>');
    }

    handleTableChange = (pagination, filters, sorter) => {
        _selectedRowKeys = [];
        _selectedRows = [];
        this.setState({
            pagination: pagination,
            selectedRowKeys: []
        });
        if (Object.keys(sorter).length !== 0) {
            if (sorter.field == 'CI_RegTime') {
                if (sorter.order == 'descend') {
                    _this.setState({
                        sorters: 'CI_RegTime desc'
                    })
                } else {
                    _this.setState({
                        sorters: 'CI_RegTime'
                    })
                }
            } else {
                if (sorter.order == 'descend') {
                    _this.setState({
                        sorters: 'CI_TypeTime desc'
                    })
                } else {
                    _this.setState({
                        sorters: 'CI_TypeTime'
                    })
                }
            }
        } else {
            _this.setState({
                sorters: 'CI_RegTime desc'
            })
        }
        setTimeout(function () {
            _this.GetCaseInfoPageList()

        }, 20)
    };

    //编辑
    edit = (record) => {
        let url = window.location.href.split("#")[0] + "#/New/CompanyRecord?ci_code=" + record.CI_Code + '&companyCode=' + _this.state.companyCode;
        window.open(url)

    }


    //单个删除方法
    DeleteCaseInfos = () => {
        $.ajax({
            url: Hcurl + "/AF_CompanyCaseInfo/DeleteCaseInfo?ci_code=" + _obj.CI_Code + '&userCode=' + EventSet.getUserInfo().CU_Code,
            type: 'post',
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                console.log(data, 'success');
                if (data.indexOf('|') >= 0) {
                    if (data.split('|')[0] == 'true') {
                        message.success(data.split('|')[1]);
                        const pagination = { ..._this.state.pagination };
                        pagination.current = 1;
                        _this.setState({
                            pagination: pagination
                        })
                        setTimeout(() => {
                            _this.GetCaseInfoPageList();
                        }, 100);
                       
                    } else {
                        message.warn(data.split('|')[1]);
                    }
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }
        })
    }

    DeleteCaseInfo = (record) => {
        _deleteInfo.setState({
            visible: true
        })
    }
    isShow = (value) => {
        console.log(value, 'value');
        if (value.length == 1) {
            this.setState({
                Companyisshow: "none"
            })
        } else
            this.setState({
                Companyisshow: "inline-block"
            })
    }

    isShows = (value) => {
        this.setState({
            visibles: value
        })
    }
    getCom_Name = () => {  //获取先行和解默认企业信息
        $.ajax({
            url: Hcurl + "/CompanyCore/GetXXHJCompanyDefultName?u_code="  + EventSet.getUserInfo().CU_Code,
            type: 'post',
            success: function (data) {
                console.log(data, 'success');
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }

        })
    }
    ModalCase = (record) => {
        this.setState({
            CaseCI_Code: record.CI_Code,
            visibles: true
        })
    }
    onSelectChange = (selectedRowKeys, selectedRows) => {
        _selectedRows = selectedRows.map(function (item, idx) {
            return item.CI_Code
        });
        _selectedRows = _selectedRows.join(';');
        this.setState({ selectedRowKeys: selectedRowKeys });
    }
    render() {
        this.columns = [
            {
                title: '登记编号',
                width: 180,
                fixed: 'left',
                key: "1",
                dataIndex: 'CI_Code',
                render: (text, record, index) => {
                    return (
                        <div>
                            <a style={{ marginRight: 10 }} onClick={v => this.ModalCase(record)}>{record.CI_Code}</a>
                        </div>
                    )
                }
            },
            {
                title: '登记时间',
                sorter: true,
                dataIndex: 'CI_RegTime',
                key: "2",
            },
            {
                title: '投诉日期',
                dataIndex: 'CI_TypeTime',
                sorter: true,
                key: "3",
            },
            {
                title: '投诉人姓名',
                dataIndex: 'CI_UserName',
                key: "4",
            }, {
                title: '联系电话',
                dataIndex: 'CI_UserPhone',
                key: "5",
            },
            {
                title: '商品/服务',
                key: "6",
                dataIndex: 'CI_ShopName',
            },
            {
                title: '购货日期',
                dataIndex: 'CI_EventTime',
                key: "7",
            }, {
                width: 150,
                title: '和解结果',
                fixed: 'right',
                dataIndex: 'CI_Result',
                key: "8",
                render: (text, record, index) => {
                    return (
                        <div>
                            {record.CI_Result.toString() == '0' ? '和解成功' : '和解失败'}
                        </div>
                    )
                },
            },
            {
                width: 150,
                title: '操作',
                fixed: 'right',
                render: (text, record, index) => {
                    return (
                        <div>
                            <a onClick={() => this.edit(record)}>编辑</a><span style={{ color: 'rgba(0, 0, 0, .25)', margin: "0 8px" }}>|</span><a onClick={() => { _obj = record; this.DeleteCaseInfo(record) }}>删除</a>
                        </div>
                    )
                },
                key: "9"
            }];
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xxl: { span: 4 },
                xl: { span: 6 },
                lg: { span: 8 },
                md: { span: 10 },
            },
            wrapperCol: {
                xxl: { span: 18 },
                xl: { span: 16 },
                lg: { span: 14 },
                md: { span: 10 },
            }
        };
        //const rowSelection = {
        //    onChange: (selectedRowKeys, selectedRows) => {
        //        _selectedRowKeys = selectedRowKeys
        //        if (selectedRowKeys.length > 0) {
        //            this.setState({
        //                selectedRowKeys
        //            })
        //        } else {
        //            this.setState({
        //                selectedRowKeys:[]
        //            })
        //        }
        //        _selectedRows = selectedRows
        //        //_selectedRows = selectedRows.map(function (item, idx) {
        //        //    return item.CI_Code
        //        //});
        //        //console.log(_selectedRows, selectedRowKeys,'_selectedRows');
        //    },
        //    onSelect: (record, selected, selectedRows, nativeEvent) => {
        //        console.log(selected, selectedRows, 'record');
        //    }
        //};
        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (
            (EventSet.getUserInfo().xxhjcompanycode === null || EventSet.getUserInfo().xxhjcompanycode === "") ? <CompanyFristLogin /> : <div id='CompanyRegistration'>
                <DeleteInfo locale={zhCN} />
                <Crumbs title={"自行和解 / 和解登记"} />
                <AllEdit />
                <CompanysModal visible={this.state.visible} setDefaultCom={this.setDefaultCom} isShow={this.isShow} />
                <RegistrationCommon CaseCI_Code={this.state.CaseCI_Code} visible={this.state.visibles} isShows={this.isShows} />
                <div style={{ minHeight: this.state.autoHeight }} className='CompanyRegistration'>
                    <div className='header'>
                        <Row>
                            <Col span={10}>
                                <ul style={{ marginBottom: 0, paddingLeft: 30 }}>
                                    <li className='li'>当前企业：{this.state.Com_Name}</li>
                                    <li className='li1'>对于非本平台办理的和解投诉单，用户可以通过本模块进行登记！</li>
                                </ul>
                            </Col>
                            <Col offset={4} span={10} style={{ textAlign: "right", marginTop: 8 }} className='headerCol'>
                                <Button type='primary' onClick={this.Record}><Icon type="plus" />登记</Button>
                                <Button onClick={this.AllEdits}>批量登记</Button>
                                {/* <Button onClick={this.toggleCompany} style={{ display: this.state.Companyisshow }}>切换企业</Button> */}
                            </Col>
                        </Row>
                    </div>
                    <div className='headerSearch'>
                        <Form className='formSearch' >
                            <Row>
                                <Col span={8}>
                                    <FormItem
                                        label="登记编号"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('Code')(
                                            <Input placeholder='请输入登记编号' />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem
                                        label="登记时间"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('editTime')(
                                            <LocaleProvider locale={zhCN}>
                                                <RangePicker
                                                    value={this.state.editTimes}
                                                    showTime={{ format: 'HH:mm' }}
                                                    format="YYYY-MM-DD HH:mm"
                                                    placeholder={['开始时间', '结束时间']}
                                                    style={{ width: "100%" }}
                                                    onChange={(v, b) => this.onDateChange(v, b)}
                                                />
                                            </LocaleProvider>
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem
                                        label="投诉日期"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('date')(
                                            <LocaleProvider locale={zhCN}>
                                                <RangePicker
                                                    value={this.state.dateTimes}
                                                    format="YYYY-MM-DD"
                                                    placeholder={['开始时间', '结束时间']}
                                                    style={{ width: "100%" }}
                                                    onChange={(v, b) => this.onDateChanges(v, b)}
                                                />
                                            </LocaleProvider>
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem
                                        label="联系电话"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('Phone')(
                                            <Input placeholder='请输入投诉人电话' />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem
                                        label="和解结果"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('result')(
                                            <Select
                                                placeholder='请选择'
                                            >
                                                <Option value="0">和解成功</Option>
                                                <Option value="1">和解失败</Option>
                                            </Select>
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={8} style={{ textAlign: "right", paddingRight: "3%", marginTop: 6 }}>

                                    <Button type="primary" htmlType="submit" onClick={this.handleSearch}>搜索</Button>
                                    <Button type="" onClick={this.reSet} style={{ marginLeft: 12, marginRight: "-3px" }}>重置</Button>
                                </Col>
                            </Row>

                        </Form>
                    </div>
                    <div className='content' style={{ position: "relative" }}>
                        <Button type="danger" ghost={true} style={{ marginBottom: 20 }} disabled={!hasSelected} onClick={() => { _obj = null; this.allDete() }}>批量删除</Button>
                        <LocaleProvider locale={zhCN}>
                            <Table
                                columns={this.columns}
                                dataSource={this.state.data}
                                rowKey={record => record.ID}
                                onChange={this.handleTableChange}
                                pagination={this.state.pagination}
                                loading={this.state.loading}
                                size="middle"
                                scroll={{ x: 1200 }}
                                bordered
                                rowSelection={rowSelection}
                            />

                        </LocaleProvider>
                        <div style={{ position: "absolute", bottom: "20px", left: "35px", display: this.state.pagetotalCount == 0 ? "none" : "block" }}>共 {this.state.pagetotalCount}条记录，第{this.state.pagination.current}/{this.state.allPage}页</div>
                    </div>
                </div>
            </div>
        )
    }
}
const RegWrap = Form.create()(App);
export default connect()(RegWrap)


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyAccord/CompanyRegistration/CompanyRegistration.js